import { createContext, useContext } from "react";

export type CaptchaContextType = {
  token: string | undefined;
  setToken: (token: string) => void;
  isInitialised: boolean;
  siteKey: string;
};

export const CaptchaContext = createContext<CaptchaContextType | undefined>(
  undefined,
);

export const useCaptcha = () => {
  const context = useContext(CaptchaContext);
  return context;
};
